<template>
    <v-container >
        <v-card class="mt-10 mx-auto" elevation-24 max-width="600">
            <v-card-title class="justify-center" >
                Email to use to purchase tickets:
            </v-card-title>
            <v-card-text>
                <v-form ref="Person" lazy-validation>
                    <v-row dense no-gutters class="justify-center">
                    <v-col cols="10">
                        <v-text-field
                            width="1rem"
                            v-model="Email"
                            label="Email Address"
                            outlined
                            dense
                            :rules="[rules.required, rules.email]"
                        ></v-text-field>
                    </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="oug" text @click="save"
                >Continue
                <v-icon>mdi-content-save-move-outline</v-icon>
                </v-btn
                >
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        data() {
    return {
      Email: '',
      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
      },
    };
    },
  methods: {
    save() {
        
    },
}
}

</script>

<style lang="scss" scoped>

</style>